import { Plat } from "../../model/menudesign/Plat";

const apiUrl = process.env.REACT_APP_API_URL;
export const PostPlats = async ( plat: Plat, page : string, id_usu : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8072/plats/${id_usu}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify(plat)
        });
        console.log("Plat keys: ", Object.keys(plat));
        console.log("plat data: ",plat);
        if (response.ok) {
            const jsonData = await response.json();
            console.log("Json data: ",jsonData);
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};